import { render } from "./ManufacturerDetails.vue?vue&type=template&id=5c0b62f0&ts=true"
import script from "./ManufacturerDetails.vue?vue&type=script&lang=ts"
export * from "./ManufacturerDetails.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__